export default "__VITE_ASSET__k41zFZF$__"